// extracted by mini-css-extract-plugin
export default {"buttonWrap":"TokenClaimSection_buttonWrap__IQqGt","buttonStyle":"TokenClaimSection_buttonStyle__AosC4"};